import { Model } from './base.model';
export class OrgType extends Model {
    shortName: string;
    fullName: string;
}
